import { Link } from "react-router-dom";
import dataproducts from "../data";

const Products = () => {
  return (
    <>
      <section className="section">
        {/* <h2>products</h2> */}
        <div className="products">
          {dataproducts.map((product) => {
            return (
              <article
                key={product.id}
                className="product"
                style={{
                  display: "inline-block",
                  margin: "5px",
                  background: "lightpink",
                  textAlign: "center",
                  borderRadius: "5px",
                  overflow: "hidden",
                  boxShadow: "0px 0px 5px solid gray",
                }}
              >
                <img src={product.image} alt={product.name} />
                <h5>{product.name}</h5>
                <button style={{ margin: "15px 0px" }}>
                  <Link to={`/products/${product.id}`}>more info</Link>
                </button>
              </article>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default Products;
